import { useState } from 'react';
import { Formik, Field, FieldArray } from 'formik';

const CheckboxDropdown = ({ name, options, onHandleChecked, selectedValues }) => {
    const [searchQuery, setSearchQuery] = useState('');

    const filteredOptions = options.filter(option =>
        option.label.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <Formik
            initialValues={{
                languages: [],
            }}
            onSubmit={(values) => { }}
        >
            <div className="">
                <div className="row mb-3">
                    <div className="col-12">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="input-field w-100"
                        />
                    </div>
                </div>
                <div className="row">
                    <FieldArray name={name}>
                        {({ push, remove, }) => (
                            filteredOptions.length > 0 ? (
                                filteredOptions.map((option, index) => (
                                    <div key={option.value} onClick={(e) => onHandleChecked(option.value, e.target.checked)} className="col-md-4 mb-3"> {/* 3 columns layout */}
                                        <div className="d-flex align-items-center">
                                            <Field
                                                type="checkbox"
                                                name={`${name}.${index}`}
                                                value={option.value}
                                                className="me-2 cursor_pointer"
                                                checked={selectedValues?.includes(option.value)}
                                            />
                                            <label htmlFor={`${name}.${index}`} className="form-check-label text-nowrap">{option.label}</label>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12">
                                    <p>No options found</p>
                                </div>
                            )
                        )}
                    </FieldArray>
                </div>
            </div>
        </Formik>
    );
};

export default CheckboxDropdown;
